import React from 'react';
import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';

i18next.addResourceBundle('en', 'forgotPass', en);

const ForgotPasswordConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/auth/forgot-password',
      component: React.lazy(() => import('./ForgotPassword')),
    },
  ],
};

export default ForgotPasswordConfig;
